import React, { memo, useState, useEffect } from "react";
import isEqual from "lodash.isequal";

import { Poi } from "../POI";
import { getPOIs } from "../../../services/areasApi/poi/get-pois";
import { toast } from "material-react-toastify";

const POIsComponent = ({
  POITypes,
  radius,
  coordinate,
  linestring,
  onMarkerClick: handleMarkerClick,
}) => {
  const [POIs, setPOIs] = useState([]);

  useEffect(() => {
    (async () => {
      const typeIds = POITypes.map(({ id }) => id);

      if (
        typeIds?.length === 0 ||
        radius <= 0 ||
        (!coordinate && !linestring)
      ) {
        setPOIs([]);

        return;
      }

      const params = {
        typeIds,
        nearby: undefined,
        intersects: undefined,
      };

      if (linestring) {
        params.intersects = {
          linestring,
          radius,
        };
      } else if (coordinate) {
        params.nearby = {
          ...coordinate,
          radius,
        };
      }

      try {
        setPOIs(await getPOIs(params));
      } catch (error) {
        toast.error("Falha ao tentar obter os pontos de interesse coletivos.");
      }
    })();
  }, [POITypes, radius, coordinate, linestring]);

  return (
    <>
      {POITypes?.length > 0 &&
        POIs.map((poi) => {
          return (
            <Poi
              key={`poi-${poi.id}`}
              poi={poi}
              onMarkerClick={handleMarkerClick}
            />
          );
        })}
    </>
  );
};

export const POIs = memo(POIsComponent, (prevProps, nextProps) => {
  const prevTypeIds = prevProps.POITypes.map(({ id }) => id);
  const nextTypeIds = nextProps.POITypes.map(({ id }) => id);

  return (
    isEqual(prevTypeIds, nextTypeIds) &&
    isEqual(prevProps.coordinate, nextProps.coordinate) &&
    prevProps.radius === nextProps.radius &&
    prevProps.linestring === nextProps.linestring &&
    prevProps.onMarkerClick === nextProps.onMarkerClick
  );
});
